import {Link} from '@primer/react'

export function MergeQueueLink({mergeQueueUrl}: {mergeQueueUrl: string | undefined}) {
  return mergeQueueUrl ? (
    <Link inline href={mergeQueueUrl}>
      merge queue
    </Link>
  ) : (
    <>merge queue</>
  )
}
